import { z } from 'zod';
export const createBoardSchema = z.object({
    workspaceId: z.string().uuid(),
    name: z.string().min(2).max(120).trim(),
    description: z.string().max(1000).trim().optional(),
    isPortfolio: z.boolean().default(false),
});
export const updateBoardSchema = createBoardSchema.omit({ workspaceId: true }).partial();
//# sourceMappingURL=board.contract.js.map